import { store } from '@/app/app-store';
import { CommunicationResponseModel, ProviderModel } from '@/app/shared/models';
import { refsService as refs } from '@/app/shared/refs.service';

import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { NotifyType } from '@/app/shared/enums/notify/notify-type.enum';
@Module({ store, name: 'notifyModule', namespaced: true, dynamic: true })
export class NotifyModule extends VuexModule {
  public providers: ProviderModel[] = [];

  @Mutation
  public SET_PROVIDER(notifyProviders: ProviderModel[]) {
    this.providers = notifyProviders;
  }

  @Action({ rawError: true })
  public async getCommunicationsByCampaign(data: {
    campaignId: string;
    communicationId: string;
    notifyId?: string;
  }): Promise<CommunicationResponseModel[]> {
    return await refs.services.notify.GetCommunications({
      campaignId: data.campaignId,
      communicationId: data.communicationId,
      queryParams: data.notifyId ? { notifyId: data.notifyId } : undefined,
    });
  }

  @Action({ rawError: true })
  public async SendMessage(data: {
    Type: string;
    Content: string;
    Recipient: string;
    Subject: string;
    Origin: string;
    OriginId: string;
    Provider: string;
    MerchantKey: string;
  }): Promise<{ ok: true }> {
    return await refs.services.notify.SendMessage(data);
  }
  @Action({ commit: 'SET_PROVIDER', rawError: true })
  public async GetProviders(): Promise<ProviderModel[]> {
    return await refs.services.notify.GetProviders();
  }
  @Action({ rawError: true })
  public async validateEmail(data: {
    To: string;
    Provider: string;
  }): Promise<boolean> {
    const result = await refs.services.notify.ValidateEmail(data);
    if (result.ValidMailbox === true && result.ValidSyntax === true)
      return true;
    else return false;
  }
  @Action({ rawError: true })
  public async BlacklistExists(data: {
    Address: string;
    MessageType: NotifyType;
  }): Promise<boolean> {
    const r = await refs.services.notify.BlacklistExists(data);
    return r;
  }
  @Action({ rawError: true })
  public async RemoveBlacklist(data: {
    Address: string;
    MessageType: NotifyType;
  }) {
    await refs.services.notify.RemoveBlacklist(data);
  }
}
